export enum KeyKeeperColor {
  Black = "black",
  Pink = "pink",
  White = "white",
  Gold = "gold",
  Green = "green",
  BlackOld = "black_old",
  PinkOld = "pink_old",
}
